// extracted by mini-css-extract-plugin
export var brand = "_2y-9";
export var compact = "_2y-6";
export var extraSmall = "_2y-7";
export var icon = "_2y-0";
export var large = "_2y-4";
export var light = "_2y-1";
export var medium = "_2y-5";
export var outline = "_2y-b";
export var primaryDark = "_2y-a";
export var primaryLight = "_2y-8";
export var primaryModern = "_2y-c";
export var success = "_2y-2";
export var successSolid = "_2y-3";